<template>
	<section class="section">
    <div class="container" style="padding-top: 60px;">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
          <ul class="breadcrumbs">
            <li>Administración</li>
            <li><i class="fa fa-angle-right"></i></li>
             <li>Usuarios</li>
            <li><i class="fa fa-angle-right"></i></li>
            <li class="active">Crear usuario</li>
          </ul>
          <div class="box-style line-top">
            <form class="form smart-form">
            
              <!-- Agregar usuarios -->
              <div class="box-header">
                <h2>NUEVO USUARIO</h2>
              </div>
              <div class="box-body">
                <div class="row">
                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>Nombre</label>
                      <input type="text" v-model="formData.firstName" class="form-control"/>
                      <span class="label label-danger" v-if="!$v.formData.firstName.required && mostrarErrores">El nombre es requerido</span>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>Apellido</label>
                      <input type="text" v-model="formData.lastName" class="form-control"/>
                      <span class="label label-danger" v-if="!$v.formData.lastName.required && mostrarErrores">El apellido es requerido</span>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>E-mail <span class="label label-danger" v-if="$v.formData.email.required&&$v.formData.email.email&&!$v.formData.email.isUnique">El email ya existe</span></label>
                      <input type="mail" v-model="formData.email" class="form-control"/>
                      <span class="label label-danger" v-if="!$v.formData.email.email && mostrarErrores">El email es requerido</span>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>Celular</label>
                      <input type="text" v-model="formData.telefonoCelular" class="form-control"/>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>Teléfono fijo</label>
                        <input type="text" v-model="formData.telefonoFijo" class="form-control" placeholder="De su área de trabajo"/>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>Interno</label>
                      <input type="text" v-model="formData.interno" class="form-control"/>
                    </div>
                  </div>

                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>Área</label>
                      <input type="text" v-model="formData.area" class="form-control"/>
                      <!-- <div class="select">
                        <select>
                          <option value="">Elija...</option>
                          <option value="">Atención al Cliente</option>
                          <option value="">Administración</option>
                          <option value="">Contaduría</option>
                          <option value="">Área comercial</option>
                          <option value="">Recepción</option>
                        </select>
                        <i class="fa fa fa-angle-down"></i>
                      </div> -->
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>Legajo</label>
                      <input type="text" v-model="formData.legajo" class="form-control"/>
                    </div>
                  </div>
                </div>
              </div><!-- fin Datos personales -->

              <div class="box-header subline-top">
                <h2>DATOS DE ACCESO</h2>
              </div>
              <div class="box-body">
                <div class="row">
                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>Usuario <span class="label label-danger" v-if="$v.formData.username.required&&!$v.formData.username.isUnique">El nombre de usuario ya existe</span></label>
                      <input type="text" v-model="formData.username" class="form-control"/>
                      <span class="label label-danger" v-if="!$v.formData.username.required && mostrarErrores">El nombre de usuario es requerido</span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>Contraseña</label>
                      <input type="password" v-model="formData.password" class="form-control"/>
                      <span class="label label-danger" v-if="!$v.formData.password.required && mostrarErrores">El password debe contener por lo menos 6 caracteres</span>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>Repetir contraseña</label>
                      <input type="password" v-model="formData.repeatPassword" class="form-control"/>
                      <span class="label label-danger" v-if="!$v.formData.repeatPassword.sameAsPassword && mostrarErrores">Debe coincidir con el password</span>
                    </div>
                  </div>
                </div>
                <div class="form-action text-center">
                  <button type="submit" class="btn btn-fill" @click.prevent="onClickGuardar">GUARDAR</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
  import {minLength, required, email, sameAs} from 'vuelidate/lib/validators'
  export default {
    data () {
      return {
        sucursal: undefined,
        formData: {
          firstName: '',
          lastName: '',
          email: '',
          telefonoFijo: '',
          telefonoCelular: '',
          interno: '',
          username: '',
          legajo: '',
          password: '',
          repeatPassword: '',
          area: '',
          sucursal: undefined
        },
        mostrarErrores: false
      }
    },
    mounted () {
      const me = this
      if (me.$route.params.sucursal) {
        me.sucursal = me.$route.params.sucursal
      }
    },
    methods: {
      onClickGuardar () {
        const me = this
        me.mostrarErrores = false
        if (me.$v.$invalid) {
          console.log(me.$v)
          me.mostrarErrores = true
          return false
        }
        if (me.sucursal) {
          me.formData.sucursal = me.sucursal
        }
        me.$http.post('/api/users/createuser', me.formData).then(({body}) => {
          if (me.sucursal) {
            me.$router.push({
              path: '/usuarios/sucursal/' + me.sucursal
            })
          } else {
            me.$router.push({
              path: '/usuarios'
            })
          }
        }, (err) => {
          console.log(err)
        })
      }
    },
    validations: {
      formData: {
        firstName: {
          required,
          minLength: minLength(3)
        },
        lastName: {
          required
        },
        email: {
          required,
          email,
          isUnique (value) {
            if (value === '') return false
            if (value.indexOf('@') === -1) return false
            return this.$http.get('/api/users/checkEmail', { params: { email: value } }).then(({body}) => {
              return body.exists === null
            })
          }
        },
        username: {
          required,
          isUnique (value) {
            if (value === '') return false
            return this.$http.get('/api/users/checkUsername', { params: { username: value } }).then(({body}) => {
              return body.exists === null
            })
          }
        },
        password: {
          required,
          minLength: minLength(6)
        },
        repeatPassword: {
          sameAsPassword: sameAs('password')
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// NewUser.vue?217209cc